module.exports = "body {\n  background-color: #F0F0F0;\n}\n#app {\n  text-align: center;\n  color: #2c3e50;\n  margin-top: 60px;\n}\n#video {\n  background-color: #000000;\n}\n#canvas {\n  display: none;\n}\nli {\n  display: inline;\n  padding: 5px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/capture/capture.component.css
// module id = ./src/app/capture/capture.component.css
// module chunks = main